import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
import AllocationCard from "../components/AllocationCard";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import { currentRequestTimeStamp } from "../../../Constants";
import { useIndentTracking } from "../hooks/useIndentTracking";
import "../Indent.css";

const ViewIndentSummary = ({
  item,
  isMobile,
  skipactive,
  autoView,
  emailTemplate,
}) => {
  const [sendinglist, setSendinglist] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const { trackIndentEvent } = useIndentTracking();
  const [updatedSummary, setUpdatedSummary] = useState(item.summary);

  const showTabs =
    item?.pm_expired_indent_id &&
    item?.indent_type === "private_market_place_indent";
  const [view, setView] = useState("latest");

  useEffect(() => {
    trackIndentEvent(
      "indent request",
      "user has clicked allocation summary button",
      `Lane - ${item?.indent_info?.origin?.location?.label || "NA"} to ${
        item?.indent_info?.destination?.location?.label || "NA"
      }, Truck Type - ${
        Array.isArray(item?.indent_info?.truck_types)
          ? item.indent_info.truck_types.length > 0
            ? item.indent_info.truck_types
                .map((truck) => truck.label)
                .join(", ")
            : "NA"
          : item?.indent_info?.truck_types?.label || "NA"
      }`
    );
  }, [item]);

  useEffect(() => {
    // is trucks requested equals trucks allocated
    if (
      parseInt(item?.allocation_status?.total_trucks_requested) ===
      parseInt(item?.allocation_status?.allocated)
    ) {
      // copy of the summary to update the transporter statuses
      const updatedTransporters = item.summary.map((transporter) => {
        if (transporter?.allocation?.allocated_status !== "yes") {
          return {
            ...transporter,
            indent_status: "not allocated", // Change status to "not allocated"
          };
        }
        return transporter;
      });

      setUpdatedSummary(updatedTransporters);
    } else {
      setUpdatedSummary(item.summary);
    }
  }, [item]);

  const onInputChange = (e, transporter, transporter_name) => {
    setDisabled(false);
    const updatedList = [...sendinglist];
    const transporterIndex = updatedList.findIndex(
      (l) => l.transporter_id === transporter
    );

    if (transporterIndex !== -1) {
      updatedList[transporterIndex].allocated_truck =
        e !== "" ? parseInt(e) : 0;
    } else {
      updatedList.push({
        transporter_id: transporter,
        transporter_name,
        allocated_truck: e !== "" ? parseInt(e) : 0,
      });
    }

    setSendinglist(updatedList);
  };

  const clickHandler = (item) => {
    setDisabled(true);
    if (sendinglist.length > 0) {
      let totalAllocated = 0;
      let invalidAllocation = false;

      sendinglist.forEach((al) => {
        if (al.allocated_truck <= 0 || al.allocated_truck === null) {
          invalidAllocation = true;
        } else {
          totalAllocated += al.allocated_truck;
        }
      });

      if (invalidAllocation) {
        toast.info("Trucks allocated cannot be negative or zero");
        return;
      }

      if (totalAllocated <= item.indent_info.truck_required) {
        const payload = {
          allocation_info: sendinglist,
          total_allocation: totalAllocated,
          field: "update_allocation_status",
        };

        axios
          .put(
            `${Urls.indent}?indent_id=${item.indent_id}&field=allocation_truck`,
            payload
          )
          .then(() => {
            toast.success("Trucks Allocated Successfully");
            // Trigger follow-up actions (like applying filter)
            apply_Filter(
              true,
              skipactive,
              10,
              (skipactive - 1) * 10 + 10,
              0,
              "active"
            );
            sendEmails(item, totalAllocated);
          })
          .catch((e) => console.error("Error allocating trucks:", e));
      } else {
        toast.info(
          "The number of trucks allocated cannot exceed the number of trucks requested"
        );
      }
    }
  };

  const sendEmails = (item, totalAllocated) => {
    const companyMail = localStorage.getItem("useremail");
    const transporterName = sendinglist[0]?.transporter_name;
    const transporterEmail = sendinglist[0]?.transporter_name; // Example, might need adjustment

    const indentTable = `
      <table border="1">
        <thead>
          <th>Indent ID</th>
          <th>Transporter Name</th>
          <th>Origin</th>
          <th>Destination</th>
          <th>Truck Type</th>
          <th>#trucks confirmed for placement</th>
          <th>Date of Placement/Contract</th>
        </thead>
        <tbody>
          <tr>
            <td>${item.display_indent_id}</td>
            <td>${transporterName}</td>
            <td>${item.indent_info.origin.location_name}</td>
            <td>${item.indent_info.destination.location_name}</td>
            <td>${item.indent_info.truck_types[0].value}</td>
            <td>${totalAllocated}</td>
            <td>${item.indent_info.placement_date}</td>
          </tr>
        </tbody>
      </table>
    `;

    const emailBody = {
      activity: "Email Request",
      type: "superlaunch",
      mail_status: "Pending",
      from_email:
        emailTemplate.allocateFromCompany === "user"
          ? companyMail
          : "connect@logisticsnow.in",
      user_type: "company",
      cc: emailTemplate.allocateCCCompany || "connect@logisticsnow.in",
      subject: emailTemplate.allocateSubjectCompany,
      content: emailTemplate.allocateContentCompany,
      to_email: companyMail,
      Application_name: "lorri",
      module_name: "Indents",
      timestamp: currentRequestTimeStamp(),
    };

    mailerAPI(emailBody, setshow);

    // Sending to transporter (if needed)
    sendinglist.forEach((transporter) => {
      if (transporter.transporter_id) {
        const transporterEmailBody = {
          ...emailBody,
          to_email: transporterEmail,
          subject: emailTemplate.allocateSubjectTransporter,
          content: emailTemplate.allocateContentTransporter,
        };
        mailerAPI(transporterEmailBody, setshow);
      }
    });
  };

  if (!showTabs) {
    return (
      <div>
        {updatedSummary?.length > 0 ? (
          <div className="d-flex flex-column" style={{ gap: "8px" }}>
            {updatedSummary.map((data, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  gap: "5px",
                }}
              >
                {autoView ? (
                  <AllocationCard item={item} data={data} />
                ) : (
                  <>
                    <div className="d-flex align-items-start">
                      <ProfileModal
                        style={{ textAlign: "left" }}
                        transporter_list={updatedSummary}
                        transporter_id={data.transporter_id}
                        transporter_name={data.transporter_name}
                        screenName={"Indent Request"}
                        moduleName={"LoRRI Indents"}
                      />
                      {data.rank && (
                        <span
                          className="ml-2 text-muted"
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ({data.rank})
                        </span>
                      )}
                    </div>
                    <div
                      className={`${data.indent_status === "rejected"
                          ? "rejected-column"
                          : data.indent_status === "accepted" ||
                            data.indent_status === "allocated"
                          ? "accepted-column"
                          : "pending-column"
                      }`}
                    >
                      {data.indent_status === "rejected"
                        ? "Rejected"
                        : data.indent_status === "accepted" ||
                          data.indent_status === "allocated"
                        ? "Accepted"
                        : "Pending"}
                    </div>
                    {data.quotation && (
                      <input
                        type="number"
                        style={{
                          margin: 0,
                          textAlign: "center",
                          padding: "0%",
                          width: "100px",
                        }}
                        onChange={(e) =>
                          onInputChange(
                            e.target.value,
                            data.transporter_id,
                            data.transporter_name
                          )
                        }
                        value={data.quotation}
                      />
                    )}
                    {data.indent_status === "allocated" && data.allocation ? (
                      <div>{data.allocation.allocated_truck}</div>
                    ) : (
                      data.indent_status === "accepted" && (
                        <input
                          type="number"
                          placeholder="0"
                          style={{ padding: "5px", width: "50px" }}
                          onInput={(e) =>
                            onInputChange(
                              e.target.value,
                              data.transporter_id,
                              data.transporter_name
                            )
                          }
                        />
                      )
                    )}
                  </>
                )}
              </div>
            ))}
            {!item.is_delete || !item.is_expired ? (
              <center style={{ marginTop: "4%" }}>
                <button
                  className="btn btn-sm btn-success"
                  disabled={disabled}
                  onClick={() => clickHandler(item)}
                >
                  Submit
                </button>
              </center>
            ) : (
              <span
                style={{
                  color: "orangered",
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                This Indent Request has been cancelled
              </span>
            )}
          </div>
        ) : (
          <span style={{ marginLeft: "34%", fontSize: "large" }}>
            <i>Awaiting Responses</i>
          </span>
        )}
      </div>
    );
  }

  return (
    <div>
      {showTabs && (
      <div className="d-flex w-100 mb-3">
        <button
          type="button"
          onClick={() => setView("latest")}
          className={`btn flex-fill rounded-pill fw-semibold ${
            view === "latest"
              ? "btn-success"
              : "btn-outline-secondary"
          }`}
          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
        >
          Latest Responses
        </button>

        <button
          type="button"
          onClick={() => setView("initial")}
          className={`btn flex-fill rounded-pill fw-semibold ${
            view === "initial"
              ? "btn-success"
              : "btn-outline-secondary"
          }`}
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        >
          Initial Responses
        </button>
      </div>
      )}


      {view === "latest" && (
        <>
          {updatedSummary?.length > 0 ? (
            <div className="d-flex flex-column">
              {updatedSummary.map((data, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    gap: "5px",
                  }}
                >
                  {autoView ? (
                    <AllocationCard item={item} data={data} />
                  ) : (
                    <>
                      <div className="d-flex align-items-start">
                        <ProfileModal
                          style={{ textAlign: "left" }}
                          transporter_list={updatedSummary}
                          transporter_id={data.transporter_id}
                          transporter_name={data.transporter_name}
                          screenName={"Indent Request"}
                          moduleName={"LoRRI Indents"}
                        />
                        {data.rank && (
                          <span
                            className="ml-2 text-muted"
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              whiteSpace: "nowrap",
                            }}
                          >
                            ({data.rank})
                          </span>
                        )}
                      </div>
                      <div
                        className={`${data.indent_status === "rejected"
                            ? "rejected-column"
                            : data.indent_status === "accepted" ||
                              data.indent_status === "allocated"
                            ? "accepted-column"
                            : "pending-column"
                        }`}
                      >
                        {data.indent_status === "rejected"
                          ? "Rejected"
                          : data.indent_status === "accepted" ||
                            data.indent_status === "allocated"
                          ? "Accepted"
                          : "Pending"}
                      </div>
                      {data.quotation && (
                        <input
                          type="number"
                          style={{
                            margin: 0,
                            textAlign: "center",
                            padding: "0%",
                            width: "100px",
                          }}
                          onChange={(e) =>
                            onInputChange(
                              e.target.value,
                              data.transporter_id,
                              data.transporter_name
                            )
                          }
                          value={data.quotation}
                        />
                      )}
                      {data.indent_status === "allocated" && data.allocation ? (
                        <div>{data.allocation.allocated_truck}</div>
                      ) : (
                        data.indent_status === "accepted" && (
                          <input
                            type="number"
                            placeholder="0"
                            style={{ padding: "5px", width: "50px" }}
                            onInput={(e) =>
                              onInputChange(
                                e.target.value,
                                data.transporter_id,
                                data.transporter_name
                              )
                            }
                          />
                        )
                      )}
                    </>
                  )}
                </div>
              ))}

              {!item.is_delete || !item.is_expired ? (
                <center style={{ marginTop: "4%" }}>
                  <button
                    className="btn btn-sm btn-success"
                    disabled={disabled}
                    onClick={() => clickHandler(item)}
                  >
                    Submit
                  </button>
                </center>
              ) : (
                <span
                  style={{
                    color: "orangered",
                    fontSize: "15px",
                    fontWeight: "600",
                  }}
                >
                  This Indent Request has been cancelled
                </span>
              )}
            </div>
          ) : (
            <div className="text-center text-muted fst-italic py-3">
              Awaiting Responses
            </div>
          )}
        </>
      )}

      {/* Initial LSP Response */}
      {view === "initial" && (
        <div className="my-2">
          <p
            style={{ fontSize: "14px", lineHeight: "1.5" }}
            className="text-muted px-4 my-4"
          >
          (This indent was shared with these LSPs first, but it was rejected or left pending until expiry before being moved to the <b>Private Marketplace</b>)
          </p>

          <div className="w-100">
            {item?.initial_lsp_response?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-sm table-bordered table-striped align-middle text-center mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "60px" }}>#</th>
                      <th className="text-start">Transporter Name</th>
                      <th style={{ width: "160px" }}>Indent Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item?.initial_lsp_response?.map((v, i) => (
                      <tr key={v?.transporter_id}>
                        <td>{i + 1}</td>
                        <td className="text-start">{v?.transporter_name}</td>
                        <td>
                          {v?.indent_status === "rejected" ? (
                            <span className="text-danger font-weight-bold">
                              Rejected
                            </span>
                          ) : v?.indent_status === "pending" ? (
                            <span className="text-warning font-weight-bold">
                              Pending
                            </span>
                          ) : (
                            <span className="badge rounded-pill bg-secondary-subtle text-secondary">
                              N/A
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center text-muted py-3">
                No responses available.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewIndentSummary;
